import { Spin } from 'antd';
import React from 'react';
import './app-spin.styles.less';

export const AppSpin: React.FC = () => (
  <Spin className="app-spin" spinning={true}>
    <div className={'app-spin'} />
  </Spin>
);
